import * as React from 'react';

type LogoProps = React.ComponentPropsWithoutRef<'svg'>;

export function Logo(props: LogoProps): JSX.Element {
  const id = React.useId();
  const paint0Id = 'p0' + id;
  const paint1Id = 'p1' + id;
  return (
    <svg
      width={128}
      height={32}
      viewBox="0 0 128 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      suppressHydrationWarning
      {...props}
    >
      <path d="M37.342 28.315l-6.384-3.68V32l6.384-3.685z" fill="#D6BBFB" />
      <path
        d="M28.724 24.636V32H16C7.178 32 0 24.822 0 16S7.178 0 16 0C5.646 8.524 7.364 16 7.364 16c0 4.758 3.878 8.636 8.636 8.636h12.73-.006z"
        fill={`url(#${paint0Id})`}
        suppressHydrationWarning
      />
      <path
        suppressHydrationWarning
        d="M32 16c0 2.277-.478 4.442-1.34 6.409h-8.878C23.525 20.82 24.63 18.544 24.63 16c0-4.765-3.872-8.636-8.636-8.636-4.765 0-8.636 3.871-8.636 8.636 0 0-1.725-7.476 8.636-16 8.822 0 16 7.178 16 16H32z"
        fill={`url(#${paint1Id})`}
      />
      <path
        d="M66.664 24a5.554 5.554 0 01-5.548-5.547v-6.815h2.626v6.815a2.923 2.923 0 005.844 0v-6.815h2.626v6.815A5.554 5.554 0 0166.664 24zM128.007 24h-2.625v-6.814a2.923 2.923 0 00-5.844 0V24h-2.626v-6.814a5.554 5.554 0 015.548-5.548 5.552 5.552 0 015.547 5.548V24zM79.815 24a6.17 6.17 0 01-6.164-6.163 6.17 6.17 0 016.164-6.164 6.17 6.17 0 016.164 6.164A6.17 6.17 0 0179.815 24zm0-9.702a3.54 3.54 0 00-3.538 3.539 3.54 3.54 0 003.538 3.538 3.54 3.54 0 003.538-3.538 3.54 3.54 0 00-3.538-3.539zM109.313 24a6.17 6.17 0 01-6.164-6.163 6.17 6.17 0 016.164-6.164 6.17 6.17 0 016.163 6.164A6.17 6.17 0 01109.313 24zm0-9.702a3.54 3.54 0 00-3.538 3.539 3.54 3.54 0 003.538 3.538 3.541 3.541 0 003.538-3.538 3.541 3.541 0 00-3.538-3.539zM97.432 18.991a5.014 5.014 0 01-5.009 5.01 5.014 5.014 0 01-5.008-5.01v-9.24h2.625v2.865h5.675v2.626H90.04v3.75a2.387 2.387 0 002.383 2.382 2.39 2.39 0 002.387-2.383h2.622zM101.605 12.616H98.98V24h2.625V12.616zM57.86 20.631A7.933 7.933 0 0059.341 16c0-4.412-3.588-8-8-8s-8 3.588-8 8 3.588 8 8 8c1.74 0 3.353-.558 4.67-1.51L57.473 24l1.88-1.832-1.495-1.537zm-6.518.743A5.38 5.38 0 0145.967 16a5.38 5.38 0 015.375-5.374 5.38 5.38 0 014.646 8.077l-1.76-1.814-1.878 1.837 1.802 1.855c-.82.5-1.782.793-2.81.793zM100.292 11.28a1.417 1.417 0 100-2.833 1.417 1.417 0 000 2.833z"
        fill="currentColor"
        className="text-gray-900 dark:text-gray-50"
      />
      <defs>
        <linearGradient
          suppressHydrationWarning
          id={paint0Id}
          x1={34.8103}
          y1={37.8813}
          x2={-1.60688}
          y2={1.81781}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.26} stopColor="#53389E" />
          <stop offset={0.89} stopColor="#9E77ED" />
        </linearGradient>
        <linearGradient
          suppressHydrationWarning
          id={paint1Id}
          x1={0.328803}
          y1={-4.42962}
          x2={26.77}
          y2={18.5002}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.26} stopColor="#53389E" />
          <stop offset={0.89} stopColor="#9E77ED" />
        </linearGradient>
      </defs>
    </svg>
  );
}
